<mat-card style="margin: 10px;">

  <ng-template #ViewTPL let-change>
    <button mat-button (click)="PDFViewChange(change.IncidentID)">View</button>
  </ng-template>

  <ejs-tab #TabGrid cssClass="underline-customize">
    <div class="e-tab-header">
      <div ><span style="color:dimgray">Approved Changes</span></div>
      <div><span style="color:dimgray">Denied Changes</span></div>
    </div>
    <div class="e-content">
      <div>
        <ejs-grid
          style="margin-top: 10px;"
          [dataSource]='ApprovedChanges'
          [allowPaging]="true"
          [allowSorting]="true"
          [allowFiltering]="true"
          [filterSettings]="{type: 'CheckBox'}"
          [allowTextWrap]="true"
          [textWrapSettings]="{ wrapMode: 'Both' }"
          [allowGrouping]="true"
          [groupSettings]="{showDropArea: false, disablePageWiseAggregates: true, columns:['ApprovedDateTime','DB_TBL','ChangeReason']}"
          [allowMultiSorting]="true"
        >
          <e-columns>
            <e-column [template]="ViewTPL" headerText='View'></e-column>
            <e-column field='ApprovedDateTime' headerText='Approved Timestamp' textAlign='Left'></e-column>
            <e-column field='ApprovedUser' headerText='Approved By' textAlign='Left'></e-column>
            <e-column field='DB_TBL' headerText='Record Type' textAlign='Left'></e-column>
            <e-column field='DB_COL' headerText='Field' textAlign='Left'></e-column>
            <e-column field='DB_OldVal' headerText='Old Value' textAlign='Left'></e-column>
            <e-column field='DB_NewVal' headerText='New Value' textAlign='Left'></e-column>
            <e-column field='ChangeReason' headerText='Reason' textAlign='Left'></e-column>
            <e-column field='ReqUser' headerText='Requested User' textAlign='Left'></e-column>
            <e-column field='ReqLab' headerText='Requested Lab' textAlign='Left'></e-column>
          </e-columns>
        </ejs-grid>
      </div>

      <div>
        <ejs-grid
          style="margin-top: 10px;"
          [dataSource]='DeniedChanges'
          [allowPaging]="true"
          [allowSorting]="true"
          [allowFiltering]="true"
          [filterSettings]="{type: 'CheckBox'}"
          [allowTextWrap]="true"
          [textWrapSettings]="{ wrapMode: 'Both' }"
          [allowGrouping]="true"
          [groupSettings]="{showDropArea: false, disablePageWiseAggregates: true, columns:['ApprovedDateTime','DB_TBL','ChangeReason']}"
          [allowMultiSorting]="true"
        >
          <e-columns>
            <e-column [template]="ViewTPL" headerText='View'></e-column>
            <e-column field='ApprovedDateTime' headerText='Denied Timestamp' textAlign='Left'></e-column>
            <e-column field='ApprovedUser' headerText='Denied By' textAlign='Left'></e-column>
            <e-column field='DB_TBL' headerText='Record Type' textAlign='Left'></e-column>
            <e-column field='DB_COL' headerText='Field' textAlign='Left'></e-column>
            <e-column field='DB_OldVal' headerText='Old Value' textAlign='Left'></e-column>
            <e-column field='DB_NewVal' headerText='Requested Value' textAlign='Left'></e-column>
            <e-column field='ChangeReason' headerText='Reason' textAlign='Left'></e-column>
            <e-column field='ReqUser' headerText='Requested User' textAlign='Left'></e-column>
            <e-column field='ReqLab' headerText='Requested Lab' textAlign='Left'></e-column>
          </e-columns>
        </ejs-grid>
      </div>

    </div>
  </ejs-tab>
</mat-card>

